
import React, { useState, useEffect } from 'react';
import GridItem from '../components/GridItem';
import {
    useSceneStore,
  } from '../store'
  import { useMediaQuery } from 'react-responsive'
import { mediaQueries } from '../config'
import Carousel from '../components/Carousel'


export default function BSCawards() {
  const [position, setPosition] = useState(0);
  const [showIntroPanel, setShowIntroPanel] = useState(false)

  const { setCursorActive, setFeatured, setModalState, setDomRef, setEvents,setMode,setScene, setScrollPos, setBookState, setTopic, setHomeMessage, setBkgdColor, setCharacter, setTalk, setShuffled, setShowBug, setContentLayout, setBookIndex, setBookOtherIndex,setLoaded } = useSceneStore(state => state.actions)
  const isMobile = useMediaQuery({ query: mediaQueries.mobile })

  function setCursor(msg, boo){
    setCursorActive(boo)
    setTopic(msg)
  }

  useEffect(() => {

  }, []);



  return (
    <div className="bsc-rules-container">

        <hr />
     {/*  <h2 style={{marginBottom: 0}}>BOOK SONG CHALLENGE 2026</h2>
          
        <p className="bsc26-intro-text">    
        Check out our winners from last year for great examples of how to create your own Book Song 
        </p>

      
        <p style={{textAlign: "center", outline: "1px solid #ffe70e", maxWidth: "800px", margin: "10px auto", padding: "20px 10px", color: "#ffe70e", textShadow: "1px 1px 4px #18b089"}}>The 7th Annual Book Song Challenge is coming in May 2026 with an all new format! Check back in April for more details...</p>


        <p style={{textAlign: "center", maxWidth: "800px", margin: "20px auto 40px"}}>
        Thanks to all who spread the word about the Book Song Challenge 2025 contest, and the 124 wonderful kids who entered. Appreciating the families, teachers, counselors, principals, and librarians who worked hard all year and shared lots of books! We can’t wait til #BookSong26.</p>
        */}
{/*
        <div className="bscoverlay-insta" >
             
             <Carousel 
               feedId="syo25Gnfvppkz6W2yXBh"  
               setShowIntroPanel={setShowIntroPanel}
               setCursor={setCursor}
               idx={1}
               />

         </div>
         */}
         

        <div style={{ width: "100%", maxWidth: "800px", margin: "20px auto 5px"}}>

           
            <a href="https://www.instagram.com/p/DYnn4FwNtHq/" target="_blank">
        <img style={{width: "100%"}} src="/assets/images/bsc-winners-website.png" alt="Book Song Challenge 2026" />
        </a>
        </div>

        <div style={{ width: "100%", maxWidth: "800px", margin: "20px auto 5px"}}>

           
            <a href="https://www.instagram.com/p/DYnx8lotJYp/" target="_blank">
        <img style={{width: "100%"}} src="/assets/images/WayPastWow-Website.png" alt="Way Past Wow!" />
        </a>
        </div>
{/*
        <p className="bsc26-intro-text">    
        Visit our <a href="https://www.instagram.com/waypastbooks/" target="_blank">Instagram page</a> to see all entries and winners from the past six years! 
        </p>

*/}


   

        <div className="bsc-date-blocks">

          <div className="date-block">
            <h3 style={{textAlign: "center", width: "100%"}}>Congratulations to our 2026 Grand Prize Winners!!!</h3>
       
          </div>

        </div>

       
             
             
     
        <div className="bsc-winners-grid">
                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrivteODRX/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/12.png'}
                            alt={"Ada"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrjEOVOH0Q/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/13.png'}
                            alt={"Addie"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrjQ_UOOHL/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/14.png'}
                            alt={"Stella and Ava"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrjhNSuHaR/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/15.png'}
                            alt={"Cameron Sahil Charlie"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrjw88OZF7/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/16.png'}
                            alt={"Cedar"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrmtsluMQz/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/17.png'}
                            alt={"Danielle & Bridget"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrm8-CucnQ/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/18.png'}
                            alt={"Danny & Owen"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrnM5huv4l/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/19.png'}
                            alt={"Ellie Amelia Lucy"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrnWufu5LI/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/20.png'}
                            alt={"E"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrnr21uZSm/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/21.png'}
                            alt={"Eva"}
                            
                        />
                    </div>
                </a>

                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYroysBuXzS/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/22.png'}
                            alt={"Henry"}
                            
                        />
                    </div>
                </a>
                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrpCBZuGEE/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/23.png'}
                            alt={"Jemma"}
                            
                        />
                    </div>
                </a>
                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrpRxkuWrm/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/24.png'}
                            alt={"Lena"}
                            
                        />
                    </div>
                </a>
                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrpdasOHwT/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/25.png'}
                            alt={"London"}
                            
                        />
                    </div>
                </a>
                <a 
                    onMouseEnter={() => setCursor('', false)} 
                    onMouseLeave={() => setCursor('', true)} 
                    className={`clickable`}
                    href="https://www.instagram.com/p/DYrpoJJuOnG/"
                    target="_blank"
                    >

                    <div className="grid-item">
                        <img
                            src={'/assets/images/bsc26/26.png'}
                            alt={"Sadie, London, Ryan, Margo"}
                            
                        />
                    </div>
                </a>
        </div>
      
       
     {/*
        <h3>The Winners Have Received</h3>
        <p style={{textAlign: 'center'}}>A <b>$1,000 Book Gift Card</b> for their school or library!<br />A <b>$75 Book Gift Card</b> for themselves!
         
        </p>
      

        <div className="green clickable" style={{
                    borderRadius: '15px',
                    overflow: 'hidden',
                    height: '315px',
                    outline: '20px solid #0b5542',
                    margin: '60px 0px 30px'
                }}>
                        <iframe width={isMobile ? '300' : '560'} height="315" src="https://www.youtube.com/embed/Mzy1FQ-ZUhI?si=X7hqCiAYz3W8uV_v" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
      
                </div>

      */}
       
  
    </div>
  );
}